import { combineReducers } from 'redux'
import { APIDataReducer } from '../Individual/APIData'
import { actionPopupReducer } from '../Individual/ActionPopup'

/** Redux root reducer */
export const rootReducer = combineReducers({
  APIData: APIDataReducer,
  actionPopup: actionPopupReducer,
})
